import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4735b5f7"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4735b5f7')) {
      api.createRecord('4735b5f7', component.options)
    } else {
      api.reload('4735b5f7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4735b5f7", function () {
      api.rerender('4735b5f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/index.vue"
export default component.exports